import React, { useState } from "react";
import CommonLayout from "../../layout/CommonLayout";
import CommonMenu from "../../layout/CommonMenu";
import CommonFooter from "../../layout/CommonFooter";
import { Link } from "react-router-dom";

const GNBPURE01002S = () => {

    const [isOpen, setIsOpen] = useState(false); // 드롭다운 메뉴 열림 상태
    const toggleDropdown = (e) => {
        e.preventDefault(); // 기본 동작 방지 (URL 변경 X)
        setIsOpen(!isOpen); // 상태 토글
    };

  return (
    <CommonLayout>
      <CommonMenu />
      <div id="contents" className="container">
        <div className="sub-title bg-type02">
          <h2>사업분야</h2>
        </div>

        <div className="location_wrap">
          <ul className="depth1">
            <li>
              <Link to="/">home</Link>
            </li>
            <li>
                <a href="#none" onClick={toggleDropdown}>
                    SM<span></span>
                </a>
                <ul className="depth2" style={{ display: isOpen ? "block" : "none" }}>
                    <li>
                        <Link to="/GNBPURE01001S">시스템통합(SI)</Link>
                    </li>
                    <li>
                        <Link to="/GNBPURE01002S">시스템유지보수(SM)</Link>
                    </li>
                    <li>
                        <Link to="/GNBPURE01003S">솔루션 제공</Link>
                    </li>
                    <li>
                        <Link to="/GNBPURE01004S">
                            애플리케이션서비스 제공 (ASP)
                        </Link>
                    </li>
                    <li>
                        <Link to="/GNBPURE01005S">IT컨설팅 서비스</Link>
                    </li>
                </ul>
            </li>
          </ul>
        </div>

        <div id="cont" className="cont">
          <div className="inner">
            <h3>
              시스템 유지보수
              <br />
              (System Maintenance, SM)
            </h3>

            <article>
              <p className="subtitle">GNB & Pure SM</p>
              <p>
                자사가 제공하는 SM 서비스는 다양한 금융기관 고객사를
                대상으로 하는{" "}
                <strong style={{ color: "red", fontWeight: "bold" }}>
                  안정적인 IT 시스템 운영 및 유지보수 서비스
                </strong>
                입니다.
                <br />
                금융 시스템은 지속적인 유지보수와{" "}
                <strong>보안 및 컴플라이언스 대응 </strong>
                이 필수적인 만큼, 다양한 금융기관 유지보수 노하우를 바탕으로
                빠르고 전문적인 대응을 제공합니다.
              </p>
            </article>

            <article>
              <p className="subtitle">비용과 리스크의 감소, 안정적인 IT 운영</p>
              <img src="/asset/img/subB/img_sm1.png" alt="고객 비즈니스 환경에 적합한 최적의 시스템 구축" className="vis_img pc" />
              <img src="/asset/img/subB/img_sm1.png" alt="고객 비즈니스 환경에 적합한 최적의 시스템 구축" className="mo" />

              <div className="table-type table-row mt50">
                <table>
                  <caption>전문 업체를 통한 유지보수(SM) 서비스</caption>
                  <colgroup>
                    <col style={{ width: "25%" }} />
                    <col style={{ width: "auto" }} />
                  </colgroup>

                  <tbody>
                    <tr>
                      <th scope="row">비용절감</th>
                      <td>
                        <ul className="bul-dot">
                          <li>일관된 서비스로 운영 비용 절감</li>
                          <li>유지보수를 고려한 설계로 불필요한 추가 비용 감소</li>
                        </ul>
                      </td>
                    </tr>

                    <tr>
                      <th scope="row">운영효율성</th>
                      <td>
                        <ul className="bul-dot">
                          <li>
                            개발 주체가 유지보수까지 이어가면서 효율성이 증가
                          </li>
                          <li>
                            금융기관의 요구사항에 맞춰 일관된 기술 지원 제공 및
                            지속적인 기능 개선 가능
                          </li>
                        </ul>
                      </td>
                    </tr>

                    <tr>
                      <th scope="row">안정성</th>
                      <td>
                        <ul className="bul-dot">
                          <li>
                            금융권의 보안 및 규제사항을 잘 이해하는 전문 업체를
                            통해 신속한 대응 가능
                          </li>
                          <li>빠른 장애 원인 파악 및 복구 시간 단축</li>
                        </ul>
                      </td>
                    </tr>

                    <tr>
                      <th scope="row">확장성 및 지속가능성</th>
                      <td>
                        <ul className="bul-dot">
                          <li>
                            금융기관 IT 로드맵을 고려한 장기적인 유지보수 및
                            시스템 확장
                          </li>
                          <li>
                            최신 기술 트렌드를 반영한 개선으로 경쟁력 강화
                          </li>
                        </ul>
                      </td>
                    </tr>

                    <tr>
                      <th scope="row">컨설팅 지원</th>
                      <td>
                        <ul className="bul-dot">
                          <li>
                            지속적으로 변화하는 금융 환경에 대하여 전문 업체를
                            통한 최신 규제 및 트렌드에 맞춘 컨설팅
                          </li>
                        </ul>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </article>
          </div>
        </div>
      </div>
      <CommonFooter />
    </CommonLayout>
  );
};

export default GNBPURE01002S;
